import type { CodeFieldFormat, CodeFieldLength, CodeFieldSeparator } from '../models/custom-field.model';

export const CODE_PREFIX_DEFAULT = '';
export const CODE_FORMAT_DEFAULT: CodeFieldFormat = 'NUMERIC';
export const CODE_LENGTH_DEFAULT: CodeFieldLength = 4;
export const CODE_SEPARATOR_DEFAULT: CodeFieldSeparator = 'NONE';

export const CODE_PREFIX_MAX_LENGTH = 5;

export function clampCodePrefix(value: string | null | undefined): string {
  return (value ?? '').trim().toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, CODE_PREFIX_MAX_LENGTH);
}

export function normalizeCodeFormat(value: unknown): CodeFieldFormat {
  if (value === 'ALPHANUMERIC' || value === 2 || value === '2') return 'ALPHANUMERIC';
  return 'NUMERIC';
}

export function normalizeCodeLength(value: unknown): CodeFieldLength {
  if (value === 6 || value === '6') return 6;
  return 4;
}

export function normalizeCodeSeparator(value: unknown): CodeFieldSeparator {
  if (value === 'HYPHEN' || value === 1 || value === '1') return 'HYPHEN';
  return 'NONE';
}

/** Frontend string → API numeric enum (`CodeFieldBodyFormat`). */
export function codeFormatToApi(format: CodeFieldFormat): number {
  return format === 'ALPHANUMERIC' ? 2 : 1;
}

/** API numeric enum → frontend string. */
export function codeFormatFromApi(value: unknown): CodeFieldFormat {
  if (value === 2 || value === '2') return 'ALPHANUMERIC';
  return 'NUMERIC';
}

/** Frontend string → API numeric enum (`CodeFieldSeparator`). */
export function codeSeparatorToApi(separator: CodeFieldSeparator): number {
  return separator === 'HYPHEN' ? 1 : 0;
}

/** API numeric enum → frontend string. */
export function codeSeparatorFromApi(value: unknown): CodeFieldSeparator {
  if (value === 1 || value === '1') return 'HYPHEN';
  return 'NONE';
}

/** Valida se a configuração do CODE é válida (regra: prefixo obrigatório quando há hífen). */
export function isCodeConfigValid(prefix: string, separator: CodeFieldSeparator): boolean {
  if (separator === 'HYPHEN' && !prefix.trim()) return false;
  return true;
}

/**
 * Gera um preview ilustrativo do formato configurado.
 * Não representa o valor real (gerado pelo backend).
 */
export function buildCodePreview(
  prefix: string,
  format: CodeFieldFormat,
  length: CodeFieldLength,
  separator: CodeFieldSeparator,
): string {
  const sampleDigits4 = '4831';
  const sampleDigits6 = '928144';
  const sampleAlpha4 = 'A7K2';
  const sampleAlpha6 = 'X92LD1';

  const code =
    format === 'ALPHANUMERIC'
      ? length === 6 ? sampleAlpha6 : sampleAlpha4
      : length === 6 ? sampleDigits6 : sampleDigits4;

  if (!prefix) return code;
  const sep = separator === 'HYPHEN' ? '-' : '';
  return `${prefix}${sep}${code}`;
}
